export default __webpack_public_path__ + "static/media/Icon4.fbb372cc.svg";